/**
 * Extracts group IDs for a specific mapping ID from the SSO mappings data
 * @param {Object} data - The mappings data object
 * @param {string} mappingId - The ID of the mapping to extract group IDs from
 * @returns {string[]} - Array of group IDs associated with the mapping
 */
export function extractGroupIdsForMapping(mappingData, mappingId) {
  // Find the specific mapping with the provided ID
  const mapping = mappingData?.find((m) => m?.id === mappingId)

  // If mapping not found, return empty array
  if (!mapping) {
    return []
  }

  // Extract group IDs from all rules in the mapping
  const groupIds = mapping?.rules
    ?.map((rule) => rule?.local?.[0]?.group?.id || null)
    ?.filter((id) => id !== null) // Filter out any nulls

  return groupIds
}
